<div class="w-full flex justify-between items-center">
  <div class="font-termina text-[24px]">Branch Condition</div>
  <div (click)="deleteCondition()">
    <span title="Delete answer option"  class="material-symbols-outlined" aria-label="Delete">delete</span>
  </div>
</div>

<div class="h-[4px] rounded-[5px] bg-base-100 m-auto mt-[10px] mb-[20px]"></div>

<div class="flex items-center justify-end mt-4">
  <button class="font-montserrat italic" (click)="addConditionComponent()">Add New Condition Component +</button>
</div>

<div class="mt-4 flex flex-col gap-2">
  @for (component of branchCondition.conditionExpressionComponents; track component) {
    <div class="flex flex-col gap-2">
      <div class="h-[4px] rounded-[5px] w-full bg-base-100 m-auto my-[2px]"></div>
      <div class="flex justify-between items-center">
        <select [(ngModel)]="component.operand" class="input font-montserrat cursor-pointer">
          @for (operandOption of getAvailableOperands(); track operandOption) {
            <option [value]="operandOption">{{ operandOption | camelCaseSplit }}</option>
          }
        </select>
        <select [(ngModel)]="component.operator" class="input font-montserrat w-[250px] cursor-pointer">
          @for (operatorOption of getAvailableOperators(component.operand); track operatorOption) {
            <option [value]="operatorOption">{{ operatorOption | camelCaseSplit }}</option>
          }
        </select>
        @if (component.operand === BranchConditionOperand.QuestionScore || component.operand === BranchConditionOperand.QuestionSetScore) {
          <input
            [(ngModel)]="component.comparisonValue"
            (ngModelChange)="setComparisonValue(component)"
            type="number"
            class="w-[300px] input font-montserrat"
            placeholder="Value"
            />
        }
        @if (component.operand === BranchConditionOperand.QuestionAnswer) {
          <select
            [(ngModel)]="component.comparisonValue"
            (ngModelChange)="setComparisonValue(component)"
            class="w-[300px] input font-montserrat cursor-pointer"
            >
            @for (answerOption of question.answerOptions; track answerOption) {
              <option [value]="answerOption.text">{{ answerOption.text }}</option>
            }
          </select>
        }
        <div (click)="deleteComponent(component)" class="mr-2">
          <span title="Delete answer option" class="material-symbols-outlined" aria-label="Delete">delete</span>
        </div>
      </div>
    </div>
  }
</div>

<div class="h-[4px] rounded-[5px] bg-base-100 m-auto mt-[10px] mb-[20px]"></div>

<div class="flex items-center justify-between">
  <div class="font-termina text-[20px]">Branch to Question:</div>
  <select [(ngModel)]="branchCondition.branchQuestionGuid" class="font-termina text-[12px] px-[18px] h-[59px] rounded-[5px] border-[4px] border-base-100 cursor-pointer">
    @for (question of availableBranchQuestions; track question) {
      <option [value]="question.guid">{{ question.text }}</option>
    }
  </select>
</div>
